// extracted by css-extract-rspack-plugin
export default {"root":"root-2KMPx","title":"title-2i3gl"};